/* GASSISA
=========================================================================================
* Descripción: 
* Historial de cambios:
* ---------------------------------------------------------------------------------------
*    Revisión   | Fecha      | Desarrollador                    | Resumen del cambio
* ---------------------------------------------------------------------------------------
*      1       | 24/09/2024 | Lic. José Luis Aragón Cervantes  | Creación
* --------------------------------------------------------------------------------------- */

import TextField from "../../ui/TextField";
import React, { Fragment, useState, useEffect } from "react";
import { Box, MenuItem } from "@mui/material";
import SizeSoftXModalPortatil from "../leyout/SizeSoftXModalPortatil";

export default function ModalEditarPartidasVentas(props) {
    const { openModal, rowSelect = {}, handleClose, handleEliminar, handleSubmitEditarPartidaVentaSumar, handleSubmitEditarPartidaVentaRestar } = props;

    const [modalVisible, setModalVisible] = useState(false); // Controla el desplazamiento del modal
    const [internalOpen, setInternalOpen] = useState(false); // Controla el estado real de apertura del modal

    const [cantidadSumar, setCantidadSumar] = useState(1);
    const [cantidadRestar, setCantidadRestar] = useState(1);

    // Efecto para manejar la apertura/cierre con retardo para permitir la animación
    useEffect(() => {
        if (openModal) {
            setInternalOpen(true); // Abre el modal de inmediato
            setTimeout(() => {
                setModalVisible(true); // Muestra el modal después de un pequeño retardo
            }, 50); // Un pequeño retraso para que la animación comience
        } else {
            setModalVisible(false); // Inicia la animación de salida
            setTimeout(() => {
                setInternalOpen(false); // Cierra el modal solo después de que la animación haya terminado
            }, 500); // 500ms coincide con la duración de la animación
        }
    }, [openModal]);

    return (
        <SizeSoftXModalPortatil
            open={internalOpen}
            onClose={handleClose}
            aria-labelledby="menu-modal-title"
            aria-describedby="menu-modal-description"
        >
            <Fragment>
                <div className="container">
                    {/* Información de la partida */}
                    <div className="partidaInfo">
                        <div><strong>ID Partida:</strong> {rowSelect.idpartida}</div>
                        <div><strong>Descripción:</strong> {rowSelect.descripcion}</div>
                        <div><strong>Cantidad Actual:</strong> {rowSelect.cantidad}</div>
                    </div>

                    {/* Separador azul cian */}
                    <hr className="separator" />

                    {/* Sección de suma */}
                    <div className="actionSection">
                        <TextField autoComplete="off"       
                            name="idcantidadsumar"
                            label="Cantidad a sumar:"
                            value={cantidadSumar}
                            onChange={(e) => setCantidadSumar(Number(e.target.value) || 1)}
                            error={false}
                            helperText=""
                            sx={{ width: '150px' }}
                            select
                        >
                            <MenuItem value="">--Seleccionar--</MenuItem>
                            {[1, 2, 3, 4, 5, 6]?.map((x) => (
                                <MenuItem key={x} value={x}>
                                    {x}
                                </MenuItem>
                            ))}
                        </TextField>
                        <button className="button" onClick={() => handleSubmitEditarPartidaVentaSumar(cantidadSumar, rowSelect.idpartida,rowSelect.clavearticulo,rowSelect.medida)}>Sumar</button>
                    </div>
                    {/* Separador azul cian */}
                    <hr className="separator" />
        
                    {/* Sección de resta */}
                    <div className="actionSection">
                    <TextField autoComplete="off"       
                            name="idcantidadrestar"
                            label="Cantidad a restar:"
                            value={cantidadRestar}
                            onChange={(e) => setCantidadRestar(Number(e.target.value) || 1)}
                            error={false}
                            helperText=""
                            sx={{ width: '150px' }}
                            select
                        >
                            <MenuItem value="">--Seleccionar--</MenuItem>
                            {[1, 2, 3, 4, 5, 6]?.map((x) => (
                                <MenuItem key={x} value={x}>
                                    {x}
                                </MenuItem>
                            ))}
                        </TextField>
                        <button className="button" onClick={() => handleSubmitEditarPartidaVentaRestar(cantidadRestar, rowSelect.idpartida,rowSelect.clavearticulo,rowSelect.medida)}>Restar</button>
                    </div>

                    {/* Separador azul cian */}
                    <hr className="separator" />

                     {/* Botón de eliminar partida */}
                     <button className="button" onClick={handleEliminar}>Eliminar Partida</button>
                </div>
            </Fragment>
        </SizeSoftXModalPortatil>
    );
}
